
import { hydrate, render } from "react-dom";
import "./typings.d";

import App from "./App";

import moment from "moment";
import { enableAppInfo } from "./enableAppInfo";
moment.locale("it");

const rootElement = document.getElementById("root");
enableAppInfo(window);
if (rootElement?.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}
